<template>
  <b-overlay :show="flagBusy">
    <portlet title="يېڭىدىن سەھىپە قوشۇش">
      <template v-slot:body>
        <flag-form
          ref="flag"
          @storing="onStoring"
          @stored="onStored"
        />
      </template>
      <template v-slot:foot>
        <b-button id="submit" @click="handleSubmit" variant="primary">
          ساقلاش
        </b-button>
        <b-button class="ml-2" variant="danger">
          بىكار قىلىش
        </b-button>
      </template>
    </portlet>
  </b-overlay>
</template>

<script>
  import Portlet from "@v@/partials/content/Portlet";
  import FlagForm from "@v@/components/forms/FlagForm";
  import BreadCrumbs from "@c@/breadcrumbs.service";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  import { debugConsole } from "@c@/helpers/helpers";
  export default {
    name: "index",
    components: { Portlet, FlagForm },
    mixins: [ formBusyMixin ],
    mounted() {
      BreadCrumbs.setBreadCrumb([]);
      BreadCrumbs.addBreadCrumb({title: 'سەھىپە باشقۇرۇش', route: {name: 'flag.home'}});
      BreadCrumbs.addBreadCrumb({title: 'يېڭىدىن سەھىپە قوشۇش'});
      if ( this.$refs.hasOwnProperty('flag') ){
        this.form = this.$refs['flag'];
      }
    },
    data(){
      return {
        flagBusy: false,
        form: {}
      };
    },
    methods: {
      handleSubmit(){
        this.form.onSubmit();
      },
      onStoring(){
        this.showBusy('flagBusy');
        debugConsole({prefix: 'flag', message: `onStored`});
      },
      onStored(state){
        this.hideBusy('flagBusy');
        debugConsole({prefix: 'flag', message: `onStored: ${state}`});
        this.$router.replace({name: 'flag.home'});
      }
    }
  }
</script>

<style scoped>

</style>
